import Header from "../../components/header/index";
import Footer from "../../components/footer/index";
import "./style.scss";

const Layout = ({ children }) => {
  return (
    <div className="layout">
      <Header />
      <div className="layout-content">{children}</div>
      <Footer />
    </div>
  );
};

export default Layout;
